<template>
  <div
    :class="[visibility ? 'bottom-18 md:bottom-16 lg:bottom-17':'-bottom-0']"
    class="select-none px-1 absolute z-10 left-1/2 transform -translate-x-1/2 transition-all duration-600 h-10 bg-secondary-800 text-white rounded-lg flex items-center text-sm">
    <slot name="commons" />
    <div class="hidden md:block">
      <slot name="desktop" />
    </div>
    <div
      ref="moreSection"
      v-outside:click="{ exclude: ['moreSection'], handler: closeMore }"
      class="relative">
      <template v-if="baseDropDownVisible">
        <base-button
          @click="toggleMore"
          size="xs" mode="tools">
          <!-- <base-icon name="more"/> -->
          <span class="count font-bold whitespace-nowrap w-18 text-center"> {{ selected }} {{ $t('app.selected_abr') }}</span>
          <base-icon
            :class="{'transform rotate-180':more}"
            class="transition-transform duration-300 ml-2"
            name="chevronup"/>
        </base-button>
        <base-drop-down autoClose :isOpen="more" position="bottom-right" customClass="w-48 p-1 bg-secondary-800 bottom-10" @toggle="closeMore" >
          <slot name="more" />
        </base-drop-down>
      </template>
      <template v-else>
        <div class="count font-bold whitespace-nowrap w-18 text-center"> {{ selected }} {{ $t('app.selected_abr') }}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-table-select-actions',
  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [String, Number],
      default: 0
    },
    total: {
      type: [String, Number],
      default: 0
    },
    baseDropDownVisible: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      more: false,
      core: false
    }
  },
  watch: {
    selected: function () {
      if (this.selected === 0) this.more = false
    }
  },
  computed: {
    allSelected: function () {
      return this.selected === this.total
    }
  },
  methods: {
    toggleMore: function () {
      this.more = !this.more
    },
    toggleCore: function () {
      this.core = !this.core
    },
    closeMore: function () {
      this.more = false
    },
    closeCore: function () {
      this.core = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
